import React, { useState } from 'react';
import { polygon, search } from '../../assets/images/dashboard-business';
import Dropdown from '../../common/dropdown/Dropdown';

type TProps = {
  setSortBy: React.Dispatch<React.SetStateAction<string>>;
  setSearch: React.Dispatch<React.SetStateAction<string>>;
};
const StatusFilter = ({ setSortBy, setSearch }: TProps) => {
  const [sortOption, setSortOption] = useState({
    value: 'createdAt',
    label: 'Most recent',
  });
  return (
    <div className='flex justify-between gap-3 flex-wrap'>
      <div className='flex gap-2 flex-wrap flex-1'>
        <div className='flex text-[13px] items-center'>
          <img src={polygon} alt='' className='h-[16px]' />
          <div>Sort by</div>
        </div>
        <div className='flex-1'>
          <Dropdown
            className='border rounded-[4px] h-[52px] text-[#212121] text-xs !h-[35px] p-1 !w-[100%] md:!w-[180px]'
            options={[
              {
                value: 'createdAt',
                label: 'Most recent',
              },
              {
                value: 'BusinessNameOptions[0]',
                label: 'Business Name',
              },
              {
                value: 'completedBy',
                label: 'Completion Date',
              },
            ]}
            placeholder={''}
            setSelectedOption={(e: { label: string; value: string }) => {
              setSortBy(e.value);
              setSortOption(e);
            }}
            width='100%'
            value={sortOption?.label}
            hideSearchBar
          />
        </div>
      </div>
      <div className='relative text-xs w-[100%] md:w-[200px]'>
        <input
          className='bg-[#ECF2FB] border-none w-[100%] outline-none pl-2 pr-[30px] h-[35px] rounded-[4px]'
          onChange={(e) => setSearch(e.target.value)}
        />
        <img src={search} className='absolute right-[10px] top-[10px] h-[15px] z-[100px]' />
      </div>
    </div>
  );
};

export default StatusFilter;
